import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { StepperHelper } from '@app/_shared/helpers/StepperHelper';
import { MatDialog } from '@angular/material/dialog';
import { Select } from '@ngxs/store';
import { AppState } from '@app/core/store/app.state';
import { Observable } from 'rxjs';
import { IMAGE_MANAGER_DIALOG_DATA, ImgModalComponent } from '../img-modal/img-modal.component';
import { ImageManagerData, MODULES_OPTIONS } from '@app/_models/images-manager/images-management.model';

@Component({
    selector: 'app-file-upload-wizard',
    templateUrl: './file-upload-wizard.component.html',
    styleUrls: ['./file-upload-wizard.component.scss'],
})
export class FileUploadWizardComponent implements OnInit, OnChanges {
    file: File;
    urlLogo: string;
    logoSucess: boolean = false;
    loading: boolean;
    logo: File;
    applyFaviconClass: boolean = false;

    assetsUrls: string = null;

    @Select(AppState.assetsUrls)
    assetsUrls$: Observable<string>;

    photo: HTMLImageElement | null = null;

    file_extension: string;

    @Input() showMessages: boolean = true;
    @Input() serverError: boolean;
    @Input() showRecommendationMessage: boolean = true;
    @Input() errorElementName: string;
    @Input() logoLoaded: string;
    @Input() deleteFileLogo: boolean;
    @Input() stepName: string;
    @Input() showDeleteBtn: boolean = true;
    @Input() showReplaceBtn: boolean = true;
    @Input() isFavicon: boolean = false;
    @Input() imageLimitInMB: number = 2;
    @Input() module: MODULES_OPTIONS;
    @Input() relation_id: number = 0;
    @Output() sendLogoToParent = new EventEmitter();
    @Output() deleteLogoEmitter = new EventEmitter();
    @Output() sendLogoUrlToParent = new EventEmitter();
    @Output() sendLogoNameToParent = new EventEmitter();
    @Output() sendManagerDataToParent = new EventEmitter();

    constructor(private stepperHelper: StepperHelper, private dialog: MatDialog) {
        this.assetsUrls$.subscribe((url) => (this.assetsUrls = url));
    }

    ngOnChanges(changes) {
        if (changes.deleteFileLogo?.currentValue) {
            this.urlLogo = null;
        }

        if (changes.logoLoaded?.currentValue) {
            this.setExtensionFromUrl(this.logoLoaded);
        }
    }
    async ngOnInit(): Promise<void> {
        const data = this.stepperHelper.getFormData(this.stepName);
        if (data && data.logo !== '') {
            this.urlLogo = data.logo;
            this.setExtensionFromUrl(this.urlLogo);
            this.sendLogoToParent.emit(await this.dataUrlToFile(data.logo, 'logo'));
        }
    }

    sendLogo(logo: File) {
        this.sendLogoToParent.emit(logo);
        this.loading = false;
    }

    async dataUrlToFile(dataUrl: string, fileName: string): Promise<File> {
        const res: Response = await fetch(dataUrl);
        const blob: Blob = await res.blob();
        return new File([blob], fileName, { type: 'image/png' });
    }

    checkFileSize(file: File) {
        if (this.imageLimitInMB === null) return true;
        const fileSizeInMegas = Number((file?.size / 1024 / 1024).toFixed(2));
        return !(fileSizeInMegas >= this.imageLimitInMB);
    }

    deleteLogo(): void {
        this.logoLoaded = '';
        this.urlLogo = '';
        this.file = null;
        this.deleteLogoEmitter.emit('delete logo');
    }

    setExtensionFromUrl(url: string): void {
        const parsedUrl = new URL(url);
        const path = parsedUrl.pathname;
        const filename = path.substring(path.lastIndexOf('/') + 1);
        const extension = filename.substring(filename.lastIndexOf('.') + 1);
        this.file_extension = extension ? extension : null;
    }

    openImageManager(): void {
        const data: IMAGE_MANAGER_DIALOG_DATA = {
            module: this.module,
            relation_id: !this.relation_id || isNaN(this.relation_id) ? 0 : this.relation_id,
            singleSelection: true,
        };
        const image_manager = this.dialog.open(ImgModalComponent, { data });

        image_manager.afterClosed().subscribe((managerData: ImageManagerData) => {
            if (managerData) {
                if (managerData.selectedFiles?.length) {
                    this.urlLogo = managerData.selectedFiles[0].url;
                    this.photo = new Image();
                    this.photo.src = managerData.selectedFiles[0].url;
                    this.logoLoaded = managerData.selectedFiles[0].url;
                    this.setFileFromUrl();
                    this.sendLogoUrlToParent.emit(this.urlLogo);
                    this.sendLogoNameToParent.emit(managerData.selectedFiles[0].filename);
                    this.sendManagerDataToParent.emit(managerData.selectedFiles[0]);
                }
            }
        });
    }

    async setFileFromUrl() {
        try {
            const urlFile = await this.dataUrlToFile(this.urlLogo, `${this.getNameFromUrl(this.urlLogo)}`);
            setTimeout(() => {
                this.sendLogo(urlFile);
            }, 1000);
        } catch (error) {
            console.error('setFileFromUrl >>> error >>> ', error);
        }
    }

    getNameFromUrl(url: string): string {
        const parsedUrl = new URL(url);
        const path = parsedUrl.pathname;
        const filename = path.substring(path.lastIndexOf('/') + 1);
        const date = new Date();
        return filename ?? `img_${date.getMonth()}_${date.getDate()}${date.getFullYear()}_${date.getMilliseconds()}`;
    }
}
